import { createSelector, createSlice, PayloadAction } from '@reduxjs/toolkit';
import { RootState } from '../store';
import { ILanguageRule, ILanguageRuleContent } from '@/types/languageRule.type';

interface ILanguageRuleState {
  rules: ILanguageRule[];
  selectedRule: ILanguageRule;
  backupSelectedRule: ILanguageRule;
}

export const initRuleContent: ILanguageRuleContent = {
  id: 0,
  name: '',
  estimatedText: '',
  privacyPageText: '',
  cartPageDateDisplay: '',
  privacyMore: '',
  soldOutCustomText: '',
  cartPageLabelText: '',
};

export const initLanguageRule: Required<ILanguageRule> = {
  id: 0,
  nameLanguage: '',
  codeLanguage: '',
  active: false,
  ruleContents: [],
  appearanceContent: {
    shippingMethodLabel: '',
    timelineOrderStepTitle: '',
    timelineOrderStepDescription: '',
    timelineShipStepTitle: '',
    timelineShipStepDescription: '',
    timelineDeliveryStepTitle: '',
    timelineDeliveryStepDescription: '',
    inputLabel: '',
    inputPlaceholder: '',
    zipcodeAvailableText: '',
    zipcodeNotAvailableText: '',
    submitButton: '',
    days: '',
    hours: '',
    minutes: '',
    seconds: '',
  },
  checkoutContent: {
    checkoutRules: [],
    productTimeLine: '',
    thankYouAndOrderStatus: '',
  },
};

const initialState: ILanguageRuleState = {
  rules: [],
  selectedRule: initLanguageRule,
  backupSelectedRule: initLanguageRule,
};

export const languageRuleSlice = createSlice({
  name: 'languageRule',
  initialState,
  reducers: {
    handleSetRules: (state, action: PayloadAction<ILanguageRule[]>) => {
      state.rules = action.payload;
    },
    handleAddRuleContent: (state, action: PayloadAction<number>) => {
      const temp = { ...initRuleContent, id: action.payload };
      state.selectedRule.ruleContents.push(temp);
    },
    handleRemoveRuleContent: (state, action: PayloadAction<number>) => {
      state.selectedRule.ruleContents = state.selectedRule.ruleContents.filter((rule) => rule.id !== action.payload);
    },
    handleSetSelectedRule: (state, action: PayloadAction<ILanguageRule>) => {
      state.selectedRule = action.payload;
    },
    handleChangeSelectedRule: (
      state,
      action: PayloadAction<{
        key: keyof ILanguageRule;
        value: ILanguageRule[keyof ILanguageRule];
      }>,
    ) => {
      state.selectedRule = {
        ...state.selectedRule,
        [action.payload.key]: action.payload.value,
      };
    },
    handleSetBackupSelectedRule: (state, action: PayloadAction<ILanguageRule>) => {
      state.backupSelectedRule = action.payload;
    },
  },
});

export const languageRulesSelector = createSelector(
  (state: RootState) => state.languageRule.rules,
  (state) => state,
);

export const selectedLanguageRuleSelector = createSelector(
  (state: RootState) => state.languageRule.selectedRule,
  (state) => state,
);

export const backupSelectedLanguageRuleSelector = createSelector(
  (state: RootState) => state.languageRule.backupSelectedRule,
  (state) => state,
);

export default languageRuleSlice;
